import api from "../../../core/api";
import type { Location } from "../components/locations/locationTypes";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.customersApiBaseUrl };
};

class LocationsApi {
  getLocationsByCustomer(customerId: string): Promise<Location[]> {
    return api
      .get<Location[]>(`/v1/internal/locations/customer/${customerId}`, getRequestConfig())
      .then((x) => x.data);
  }
}

export default new LocationsApi();
